<style lang="less">
    @import "../verificationOriginal/index.less";
</style>
<template>
    <div class="ordercommon">

        <div class="vmain-content">




            <div style="display: flex;width: 1334px;margin: 0 auto">
                <Anchor class="verification_anchor" :bounds="-100">
                    <AnchorLink v-if="this.$route.params.type!=0 && this.$route.params.type!=1" class="verification_anchor_link" :scroll-offset="-100" href="#six" title="证据文件核验" />
                    <AnchorLink class="verification_anchor_link" :scroll-offset="-100" href="#one" title="证书信息" />
                    <!-- <AnchorLink class="verification_anchor_link" :scroll-offset="-100" href="#two" title="互联网法院信息" /> -->
                    <AnchorLink class="verification_anchor_link" :scroll-offset="-100" href="#there" title="版权区块链信息" />
                    <AnchorLink class="verification_anchor_link" :scroll-offset="-100" href="#four" title="CA电子签名信息" />
                    <AnchorLink class="verification_anchor_link" :scroll-offset="-100" href="#five" title="国家授时中心信息" />
                </Anchor>
                <div>
                    <div class="orderTitleTopStyle">
                        <span>前海版权公共服务平台可信存证核验</span>
                        <img src="../verificationOriginal/images/tittleBottom.png" alt='版权登记'/>
                    </div>
                    <!---->
                    <div v-if="this.$route.params.type!=0 && this.$route.params.type!=1" id="six" class="orderContentStyle bgImg" style="height:auto;margin-bottom:20px;background:#fff;border:1px solid #eee;">
                        <div class="mewAddsty">
                            <div class="mewAddsty_left">证据文件核验：</div>
                            <div class="mewAddsty_right">
                                <div class="myupleft">
                                    <Upload
                                            class="vertical_upload"
                                            ref="upload"
                                            :show-upload-list="false"
                                            :before-upload="handleBeforeUpload"
                                            :multiple="false"
                                            type="drag"
                                            action=""
                                            style="display: inline-block;vertical-align: top;border-radius:4px;width:175px;height:154px;border:1px dashed #B9B9B9;">

                                        <!--  没有图片时  -->
                                        <div v-if="uploadProgress == -1" class="upload_text">
                                            <div class="upload_text_icon">
                                                <img v-if="addIcon == 'addIcon' " src="./../../main-components/images/add_icon.png" alt='版权登记'>
                                                <img v-else src="./../../main-components/images/add_file_icon.png" alt='版权登记'>
                                                <p v-if="tipsText!=''" class="upload_text_tips">{{ tipsText }}</p>
                                            </div>
                                        </div>

                                        <!--  图片上传时  -->
                                        <div v-else-if="uploadProgress == 1" class="upload_ing">
                                            <!-- <div class="upload_ing_text">识别中...</div> -->
                                            <div class="upload_ing_text">
                                                <div class="upload_ing_desc">{{processData}}%</div>
                                                <div class="upload_ing_desc" style="font-size:14px;">解析中</div>
                                                <div class="upload_progress_shadow" :style="{height:processData+'%'}"></div>
                                            </div>
                                        </div>

                                        <!--  图片上传成功  -->
                                        <div v-else-if="uploadProgress == 0" class="upload_success">
                                            <img class="upload_success_img"
                                                :src="fileType == 'img' ? returnImg  : returnImg"
                                                 alt='版权登记'>
                                            <div class="upload_success_btn">重新上传</div>
                                        </div>
                                    </Upload>
                                </div>
                                <div @click="getEvidencePack" class="mewAddsty_btn">开始核验</div>
                            </div>
                        </div>
                        <div class="mewAddsty_bottom" v-if="returnImg!='' && flag==true">
                            <div class="mewAddsty_bottom_left">核验结果：</div>
                            <div class="mewAddsty_bottom_right">
                                <div class="mewAddsty_bottom_right1">
                                    <img class="mewAddsty_bottom_right1_1" :src="certPageObj.isSame==true?rightPhoto:wrongPhoto" alt='版权登记'/>
                                    <div :style="{color:certPageObj.isSame==true?'#54D329':'#FA6400'}" class="mewAddsty_bottom_right1_2">{{certPageObj.isSame==true?'核验通过':'核验未通过'}}</div>
                                </div>
                                <div class="mewAddsty_bottom_right2">哈希值（SHA256）{{certPageObj.isSame==true?'一致':'不一致'}}，{{certPageObj.isSame==true?'该证据文件系原始证据文件。':'该证据文件不是原始证据文件。'}}</div>
                                <div class="mewAddsty_bottom_right3">
                                    <p>原始证据包哈希值（SHA256）：{{certPageObj.oldHash}}</p>
                                    <p style="margin-bottom:58px;">当前上传证据包哈希值（SHA256）：{{certPageObj.newHash}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 证书内容信息 -->
                    <div id="one" class="orderContentStyle bgImg">
                        <div class="orderContent-tip" style="marginBottom:20px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/oneIcon.png" style="verticalAlign:middle" alt='版权登记'/>
                                <span>证书内容信息</span>
                            </div>
                            <Tooltip style="float: right;" max-width="160" content="前海版权公共服务平台将证书中主要文字内容摘取出来作为证书内容信息，它是证书的主体部分，用以说明证书的申请人和作品之间的关系及版权相关信息。通过SHA256散列函数算法得出证书内容完整性校验值，作为向国家授时中心可信时间服务申请授时凭证的事物编号，以此来保证证书内容信息与授时时间信息相对应。">
                                <div class="floatDiv" data-num="0" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color:#666;font-size:12px">证书内容信息的重要性</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="top:533px;left: 1138px;height:286px;" v-if="newBlock">-->
<!--                            <p>-->
<!--                                前海版权公共服务平台将证书中主要文字内容摘取出来作为证书内容信息，它是证书的主体部分，用以说明证书的申请人和作品之间的关系及版权相关信息。通过SHA256散列函数算法得出证书内容完整性校验值，作为向国家授时中心可信时间服务申请授时凭证的事物编号，以此来保证证书内容信息与授时时间信息相对应。</p>-->
<!--                        </div>-->
                        <div class="orderContent-center" style="margin-bottom: 25px">
                            <div class="spanPosition">
                                <span style="font-weight:600;font-size:14px">证书内容完整性校验值</span>
                                <span style="font-size: 14px;color:#999">（该值由证书中摘取的主要内容通过SHA256算法得出）</span>
                            </div>
                            <div style="margin-bottom: 20px;margin-top:15px">
                                <span id="public_text" class="input-span-styles">{{recodes.tscData}}</span>
                            </div>
                            <div class="spanPosition">
                                <span style="font-weight: 600;font-size:14px">证书中摘取的主要内容</span>
                            </div>
                            <div style="margin-top: 20px">
                                <textarea id="public_text" class="textarea-style" :value="recodes.summary"/>
                            </div>
                        </div>
                        <div style="border-bottom: 1px dashed #efefef"></div>
                        <div class="orderContent-tip" style="margin-top:22px;margin-bottom:18px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/book2.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>内容核验</span>
                                <span style="color:red;font-size:12px">*<strong>千万不要</strong>使用火狐浏览器访问，会导致加密错误</span>
                            </div>
                            <Tooltip style="float: right;" max-width="160" content="内容核验的意义在于，通过在第三方平台，使用SHA256散列函数算法计算证书内容信息的完整性校验值，并与证书内容完整性校验值匹配，来验证证书内容信息的完整和未被篡改。">
                                <div class="floatDiv" data-num="1" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">为什么要内容核验</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="top: 1135px;left:1161px" v-if="newBlock1">-->
<!--                            <p>内容核验的意义在于，通过在第三方平台，使用SHA256散列函数算法计算证书内容信息的完整性校验值，并与证书内容完整性校验值匹配，来验证证书内容信息的完整和未被篡改。</p>-->
<!--                        </div>-->
                        <div style="overflow:'hidden">
                            <div class="marginLeft60 floatImg">
                                <span class="step-one">step 01</span>
                                <div class="btn-copy-style">复制证书中摘取的主要内容</div>
                                <button class="btn primary btn-120"
                                        v-clipboard:copy="recodes.summary"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onError">点击复制核验内容
                                </button>

                            </div>
                            <div class="floatImg">
                                <span class="step-one">step 02</span>
                                <div class="step-two">
                                    <span class="step-three">选择下方任意网址，粘贴已复制好的内容，使用SHA256加密</span>
                                    <img src="../verificationOriginal/images/sha34.png" style="float: right" alt='版权登记'/>
                                </div>
                                <div class="step-four">
                                    <a class='hash-link lineHeight16' target="_blank" href="http://www.jsons.cn/sha/">http://www.jsons.cn/sha/</a>
                                    <a class='hash-link lineHeight16' target="_blank" href="http://encode.chahuo.com/">http://encode.chahuo.com/</a>
                                    <a class='hash-link lineHeight16' target="_blank"
                                       href="https://md5file.com/calculator">https://md5file.com/calculator</a>
                                    <a class='hash-link lineHeight16' target="_blank"
                                       href="https://hash.online-convert.com/sha256-generator">https://hash.online-convert.com/sha256-generator</a>
                                </div>

                            </div>
                            <div class="floatImg2">
                                <span class="step-one">step 03</span>
                                <span class="step-six">得出来的结果与你拥有的证书内容完整性校验值比对，完全一致即表明证书承载的信息没有任何问题。</span>
                            </div>
                        </div>
                    </div>

                    <!-- 互联网法院信息 -->
                    <!-- <div id="two" class="orderContentStyle bgImg2">
                        <div class="orderContent-tip" style="margin-bottom:20px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/clock1.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>互联网法院信息</span>
                            </div>
                        </div>
                        <div style="padding-left: 66px">
                            <span style="font-weight:600;font-size:14px">北京互联网法院-天平链核验</span>
                            <div style="margin:20px 0px 10px">
                                <span class="span-line20">天平链存证编码</span>
                            </div>
                            <div>
                                <span id="public_text" class="input-span-styles">{{tinaPingCode}}</span>
                                <button class="button-copy"
                                        v-clipboard:copy="tinaPingCode"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onError">复制存证编码
                                </button>

                            </div>
                            <p style="color: #ff0000;line-height: 18px;margin-bottom: 16px;font-size:12px">
                                注：请复制天平链存证编码，前往北京互联网法院-天平链公示网站进行核验
                            </p>
                        </div>
                        <div style="border-bottom: 1px dashed #efefef"></div>
                        <div class="orderContent-tip" style="margin-top: 22px; margin-bottom: 0px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/clock2.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>天平链核验</span>
                            </div>
                        </div>
                        <div style="height:18px"></div>
                        <div style="text-align:center;padding-bottom:60px" class="astyle">
                            <img src="../verificationOriginal/images/beijingicon.png"
                                 style="width:277px;height:48px;margin-bottom:20px;margin-top:13px" alt='版权登记'/>
                            <a target='_blank' href="http://bc.bjinternetcourt.gov.cn:8888/index.html#/pcSearch"><input
                                    type="button" class="input-btn-seck" value="去北京互联网法院官网核验"/></a>
                        </div>
                    </div> -->

                    <!-- {/* 版权区块链公示信息 */} -->
                    <div id="there" class="orderContentStyle bgImg4">
                        <div class="orderContent-tip" style="margin-bottom: 0px;position:relative">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/eightIcon.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>版权区块链公示信息</span>
                            </div>
                            <Tooltip :transfer="true" placement="left" style="float: right;" max-width="300" content="版权区块链联盟是在全国打击侵犯知识产权和制售假冒伪劣商品工作领导小组办公室的指导下、中国产学研合作促进会反侵权假冒创新战略联盟的支持下，由版权业务相关、拥有独特行业资源的企业或组织等共同组成。联盟使用版权区块链保障信息不可篡改不可伪造，并可自动共识到联盟成员各方，包括司法鉴定中心、律师事务所等法律机构，在版权区块链联盟网站上进行公示信息即是版权信息的宣告，也可由社会各方共同监督保障证书内容信息真实不被篡改。">
                                <div class="floatDiv" data-num="6" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">公示信息的重要性</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="top:1955px;left: 1161px;height: 415px" v-if="newBlock6">-->
<!--                            <p style="margin: 26px 16px">-->
<!--                                版权区块链联盟是在全国打击侵犯知识产权和制售假冒伪劣商品工作领导小组办公室的指导下、中国产学研合作促进会反侵权假冒创新战略联盟的支持下，由版权业务相关、拥有独特行业资源的企业或组织等共同组成。联盟使用版权区块链保障信息不可篡改不可伪造，并可自动共识到联盟成员各方，包括司法鉴定中心、律师事务所等法律机构，在版权区块链联盟网站上进行公示信息即是版权信息的宣告，也可由社会各方共同监督保障证书内容信息真实不被篡改。</p>-->
<!--                        </div>-->
                        <div style="padding-left: 69px;margin-top: 20px">
                            <div class="spanPosition">
                                <span style="font-weight:600">公示Hash-电子数据完整性校验值</span>
                                <span style="font-size: 14px; color: #999999">（该值由电子数据内容通过SHA256算法得出）</span>
                                <p style="margin: 10px 0 20px">{{recodes.publicHash}}</p>
                            </div>
                            <div style="margin-bottom:10px">
                                <span class="span-line20" style="font-weight: 600">电子数据内容：</span>
                            </div>
                            <!-- {/* 展开查看全部 */} -->
                            <!-- {/* 签名结果 */} -->
                            <div>
                                <div class="zhankaiBox" style="display:block">
                                    <span class="zhankaiSpan">签名结果：{{recodes.caSignResult}}</span>
                                    <span class="zhankaispan2" @click="twolistclick($event)">展开</span>
                                </div>
                                <div class="zhankaiBox2" style="display:none">
                                    <span>签名结果：{{recodes.caSignResult}}</span>
                                    <p class="closeContent" @click="closelistclick($event)">收起</p>
                                </div>
                            </div>
                            <!-- {/* 用户证书公钥 */} -->
                            <div>
                                <div class="zhankaiBox" style="display:block">
                                    <span class="zhankaiSpan">用户证书公钥：{{recodes.caPubKey}}</span>
                                    <span class="zhankaispan2" @click="twolistclick($event)">展开</span>
                                </div>
                                <div class="zhankaiBox2" style="display:none">
                                    <span>用户证书公钥：{{recodes.caPubKey}}</span>
                                    <p class="closeContent" @click="closelistclick($event)">收起</p>
                                </div>
                            </div>
                            <p style="color: #ff0000;line-height: 18px;margin-bottom: 16px;font-size:12px">
                                注：公示Hash在版权区块链联盟网站进行公示
                            </p>
                        </div>
                        <div style="border-bottom:1px dashed #efefef;margin-top:25px"></div>
                        <div class="orderContent-tip"
                             style="margin-top: 22px;margin-bottom: 0px;position:relative;height:32px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/nineIcon.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>公示核验</span>
                            </div>
                            <Tooltip :transfer="true" style="float: right;" max-width="160" content="前往版权区块链联盟网站核验公示信息，就能查看公示Hash是否真实的存在于区块链上和在版权区块链联盟网站上进行了公示。公示Hash由签名结果加上签名公钥经SHA256散列函数算法计算得到。">
                                <div class="floatDiv" data-num="7" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">为什么要公示核验</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="left: 1161px;height:200px" v-if="newBlock7">-->
<!--                            <p>-->
<!--                                前往版权区块链联盟网站核验公示信息，就能查看公示Hash是否真实的存在于区块链上和在版权区块链联盟网站上进行了公示。公示Hash由签名结果加上签名公钥经SHA256散列函数算法计算得到。</p>-->
<!--                        </div>-->
                        <p style="margin: 20px 0px 20px 60px;font-weight: 600">1、公示Hash核验&nbsp;&nbsp;<span
                                style="color: red; font-size: 12px">*<strong>千万不要</strong>使用火狐浏览器访问，会导致加密错误</span></p>
                        <div style="overflow: hidden;height:121px">
                            <div class="marginLeft60 floatImg">
                                <span class="step-one">step 01</span>
                                <div class="btn-copy-style">复制证书中摘取的主要内容</div>
                                <button class="btn primary btn-120"
                                        v-clipboard:copy="copyUrls"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onError">点击复制核验内容
                                </button>
                                <!-- {
                                    primitiveTscCaData &&
                                    <CopyToClipboard onCopy={this.textCopy} text={`${primitiveTscCaData}\n`}>
                                        <button class="btn primary" style={{ width: '120px', height: '30px', position: 'absolute', top: '65px', left: '107px', fontSize: '13px',padding:'0' }} @click={()=>this.copyUrl()}>点击复制核验内容</button>
                                    </CopyToClipboard>
                                } -->
                            </div>
                            <div class="floatImg">
                                <span class="step-one">step 02</span>
                                <div class="step-two">
                                    <span class="step-three">选择下方任意网址，粘贴已复制好的内容，使用SHA256加密</span>
                                    <img src="../verificationOriginal/images/sha34.png" style="float: right" alt='版权登记'/>
                                </div>
                                <div class="step-four">
                                    <a class='hash-link lineHeight16' target="_blank" href="http://www.jsons.cn/sha/">http://www.jsons.cn/sha/</a>
                                    <a class='hash-link lineHeight16' target="_blank" href="http://encode.chahuo.com/">http://encode.chahuo.com/</a>
                                    <a class='hash-link lineHeight16' target="_blank"
                                       href="https://md5file.com/calculator">https://md5file.com/calculator</a>
                                    <a class='hash-link lineHeight16' target="_blank"
                                       href="https://hash.online-convert.com/sha256-generator">https://hash.online-convert.com/sha256-generator</a>
                                </div>

                            </div>
                            <div class="floatImg2">
                                <span class="step-one">step 03</span>
                                <span class="step-six">得出来的结果与你拥有的证书内容完整性校验值比对，完全一致即表明证书承载的信息没有任何问题。</span>
                            </div>
                        </div>
                        <div style="display:flex;justify-content:space-between;align-items:center;"><p style="margin: 25px 0 15px 60px; font-weight:600">2、公示信息核验</p><p @click="openDaog" style="color:#999;margin-right: 25px;font-size: 12px;cursor: pointer;">去广州互联网法院核验</p></div>
                        <div style="text-align: center;padding-bottom:60px">
                            <img src="../verificationOriginal/images/tenIcon.png"
                                 style="margin-bottom: 20px;margin-top: 13px" alt='版权登记'/>
                            <a class="input-btn-seck" target="_blank" :href="herfUrl">去版权区块链联盟核验</a>
                        </div>
                    </div>

                    <!--  签名信息  -->
                    <div id="four" class="orderContentStyle bgImg3">
                        <div class="orderContent-tip" style="margin-bottom: 0px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/fontIcon.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>签名信息</span>
                            </div>
                            <Tooltip :transfer="true" style="float: right;" placement="left" max-width="255" content="前海版权公共服务平台使用天威诚信颁发的数字证书，对证书内容完整性校验值（事务编号）、授时时间、授时凭证加密后进行签名，生成签名结果，来确保签名人认可签名内容的真实性。北京天威诚信电子商务服务有限公司是经工业和信息化部许可的电子认证服务机构，提供制作、签发、管理电子签名认证证书服务，并且可确认签发的电子签名真实性。">
                                <div class="floatDiv" data-num="4" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">数字签名的重要性</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="left: 1161px;height:314px" v-if="newBlock4">-->
<!--                            <p>-->
<!--                                前海版权公共服务平台使用天威诚信颁发的数字证书，对证书内容完整性校验值（事务编号）、授时时间、授时凭证加密后进行签名，生成签名结果，来确保签名人认可签名内容的真实性。北京天威诚信电子商务服务有限公司是经工业和信息化部许可的电子认证服务机构，提供制作、签发、管理电子签名认证证书服务，并且可确认签发的电子签名真实性。</p>-->
<!--                        </div>-->
                        <div style="height:20px"></div>
                        <div style="padding-left: 69px">
                            <div style="margin-bottom: 5px">
                                <span class="span-line20">数字证书持有人：</span>
                                <span style="line-height: 20px" class="word-warp-span">{{recodes.caUser}}</span>
                            </div>
                            <div style="margin-bottom: 10px">
                                <span lass="span-line20">证书签发机构：</span>
                                <span style="line-height: 20px" class="word-warp-span">{{recodes.caOrganization}}</span>
                            </div>
                            <!-- {/* 展开查看全部 */} -->
                            <!-- {/* 签名原文 */} -->
                            <div>
                                <div class="zhankaiBox" style="display:block">
                                    <span class="zhankaiSpan">签名原文：{{recodes.callBackCaRequestData}}</span>
                                    <span class="zhankaispan2" @click="newslistclick($event)">展开</span>
                                </div>
                                <div class="zhankaiBox2" style="display:none">
                                    <span>签名原文：{{recodes.callBackCaRequestData}}</span>
                                    <p class="closeContent" @click="closelistclick($event)">收起</p>
                                </div>
                            </div>
                            <!-- {/* 用户证书公钥 */} -->
                            <div>
                                <div class="zhankaiBox" style="display:block">
                                    <span class="zhankaiSpan">用户证书公钥：{{recodes.caPubKey}}</span>
                                    <span class="zhankaispan2" @click="newslistclick($event)">展开</span>
                                </div>
                                <div class="zhankaiBox2" style="display:none">
                                    <span>用户证书公钥：{{recodes.caPubKey}}</span>
                                    <p class="closeContent" @click="closelistclick($event)">收起</p>
                                </div>
                            </div>
                            <!-- {/* 签名结果 */} -->
                            <div>
                                <div class="zhankaiBox" style="display:block">
                                    <span class="zhankaiSpan">签名结果：{{recodes.caSignResult}}</span>
                                    <span class="zhankaispan2" @click="newslistclick($event)">展开</span>
                                </div>
                                <div class="zhankaiBox2" style="display:none">
                                    <span>签名结果：{{recodes.caSignResult}}</span>
                                    <p class="closeContent" @click="closelistclick($event)">收起</p>
                                </div>
                            </div>
                        </div>
                        <div style="border-bottom:1px dashed #efefef;margin-top:25px"></div>
                        <div class="orderContent-tip" style="margin-top: 22px;margin-bottom: 0px;position:relative">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/fiveIcon.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>签名核验</span>
                            </div>
                            <Tooltip :transfer="true" style="float: right;" max-width="160" content="通过访问天威诚信提供的数字证书签名核验页面，将签名原文、签名结果、签名公钥输入后即可进行核验。核验成功即可查看所有加密后的信息，以此来保证签名人认可签名的信息，签名信息不被伪造。">
                                <div class="floatDiv" data-num="5" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">为什么要签名核验</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="left: 1161px;height:200px" v-if="newBlock5">-->
<!--                            <p>-->
<!--                                通过访问天威诚信提供的数字证书签名核验页面，将签名原文、签名结果、签名公钥输入后即可进行核验。核验成功即可查看所有加密后的信息，以此来保证签名人认可签名的信息，签名信息不被伪造。</p>-->
<!--                        </div>-->
                        <div style="text-align: center;padding-bottom: 60px;margin-top:20px" class="astyle">
                            <img src="../verificationOriginal/images/sixIcon.png"
                                 style="margin-bottom: 20px; margin-top: 13px" alt='版权登记'/>
                            <!-- {
                                window.location.origin == "http://devv.bqj.cn" || window.location.origin == "http://testv.bqj.cn" || window.location.origin == "http://localhost:8080" ? -->
                            <div>
                                <form method="post" action="https://www.itrusign.com/esp/cert/verifyAct"
                                      target="_blank">
                                    <input type="hidden" name="caData" :value="recodes.callBackCaRequestData"
                                           readOnly={true}/>
                                    <input type="hidden" name="caSignedMsg" :value="recodes.caSignResult"
                                           readOnly={true}/>
                                    <input type="hidden" name="caPubKey" :value="recodes.caPubKey" readOnly={true}/>
                                    <input type="submit" class="input-btn-seck" value="去天威诚信官网核验"/>
                                </form>
                            </div>
                            <!-- :
                            <div>
                                <form method="post" action="https://www.itrusign.com/esp/cert/verifyAct" target="_blank">
                                    <input type="hidden" name="caData" :value="recodes.callBackCaRequestData" readOnly={true} />
                                    <input type="hidden" name="caSignedMsg" :value="recodes.caSignResult" readOnly={true} />
                                    <input type="hidden" name="caPubKey" :value="recodes.caPubKey" readOnly={true} />
                                    <input type="submit" class="input-btn-seck" value="去天威诚信官网核验" />
                                </form>
                            </div> -->
                            <!-- } -->
                        </div>
                    </div>

                    <!-- 授时时间信息 -->
                    <div id="five" class="orderContentStyle bgImg2">
                        <div class="orderContent-tip" style="margin-bottom:0px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/clock1.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>授时时间信息</span>
                            </div>
                            <Tooltip :transfer="true" style="float: right;" max-width="160" content="法律中的很多规定，都以时间作为事实依据，然而创作者或者前海版权公共服务平台都很难自证采用的时间是真实和有法律效用的。中国科学院国家授时中心负责中国标准时间的产生、保持和发播，提供可信授时服务，可以作为时间真实性和有效性的权威证据。">
                                <div class="floatDiv" data-num="2" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">可信授时的重要性</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="left:1161px;height:228px" v-if="newBlock2">-->
<!--                            <p>-->
<!--                                法律中的很多规定，都以时间作为事实依据，然而创作者或者前海版权公共服务平台都很难自证采用的时间是真实和有法律效用的。中国科学院国家授时中心负责中国标准时间的产生、保持和发播，提供可信授时服务，可以作为时间真实性和有效性的权威证据。</p>-->
<!--                        </div>-->
                        <div style="padding-left: 66px;margin-top:20px;">
                            <div style="margin-bottom: 5px">
                                <span class="span-line20">证书的授时时间：</span>
                                <span class="word-warp-span">{{recodes.tscTime}}</span>
                            </div>
                            <div style="margin-bottom: 5px">
                                <span class="span-line20">授时凭证编号：</span>
                                <span class="word-warp-span">{{recodes.tscVoucherNum}}</span>
                            </div>
                            <div style="margin-bottom: 8px">
                                <span class="span-line20">事物编号：</span>
                                <span class="word-warp-span">{{recodes.tscData}}</span>
                            </div>
                            <div style="margin-bottom: 8px">
                                <span class="span-line20">凭证字符串：</span>
                                <span class="tsc-span">{{recodes.tscCtsr}}</span>
                            </div>
                            <p style="color: #ff0000;line-height: 18px;margin-bottom: 16px;font-size:12px">
                                注：授时时间由中国科学院国家授时中心可信时间服务提供授时
                            </p>
                        </div>
                        <div style="border-bottom: 1px dashed #efefef"></div>
                        <div class="orderContent-tip" style="margin-top: 22px; margin-bottom: 0px">
                            <div class="floatDiv">
                                <img src="../verificationOriginal/images/clock2.png" style="vertical-align: middle" alt='版权登记'/>
                                <span>授时时间核验</span>
                            </div>
                            <Tooltip :transfer="true" placement="left" style="float: right;" max-width="255" content="前海版权公共服务平台将证书内容完整性校验值作为事物编号，将信息传递给中国科学院国家授时中心可信时间服务，获得授时时间和授时凭证，以保证证书中采用的时间是精准和有效的时间。该时间可在中国科学院国家授时中心可信时间服务平台网站，通过事物编号、授时时间和授时凭证进行核验，以保证时间的精确和不可伪造。">
                                <div class="floatDiv" data-num="3" style="float: right; cursor:pointer">
                                    <img src="../verificationOriginal/images/wenhaoYellow.png"
                                         style="vertical-align: middle" alt='版权登记'/>
                                    <span style="color: #666;font-size:12px">为什么要授时时间核验</span>
                                </div>
                            </Tooltip>
                        </div>
<!--                        <div class="floatInfo" style="left: 1137px;height:285px" v-if="newBlock3">-->
<!--                            <p>-->
<!--                                前海版权公共服务平台将证书内容完整性校验值作为事物编号，将信息传递给中国科学院国家授时中心可信时间服务，获得授时时间和授时凭证，以保证证书中采用的时间是精准和有效的时间。该时间可在中国科学院国家授时中心可信时间服务平台网站，通过事物编号、授时时间和授时凭证进行核验，以保证时间的精确和不可伪造。</p>-->
<!--                        </div>-->
                        <div style="height:18px"></div>
                        <div style="text-align:center;padding-bottom:60px" class="astyle">
                            <img src="../verificationOriginal/images/twoIcon.png"
                                 style="margin-bottom:20px;margin-top:13px" alt='版权登记'/>
                            <a target='_blank' href="https://ttas.ntsc.ac.cn/"><input type="button"
                                                                                      class="input-btn-seck"
                                                                                      value="去可信时间服务网站核验"/></a>

                            <!-- 有一部分代码暂时删除（链接） -->
                        </div>
                    </div>

                </div>

            </div>


        </div>
        <div class="mydiag" v-if="showOg">
            <div class="mydiag_content">
                <div class="mydiag_title">
                   <p></p>
                   <div>存证编码</div>
                   <img @click="closeZfb()" src="./../coupon/images/close.png" />
               </div>
               <div class="mydiag_tonle">
                   {{barcode}}
               </div>
               <div style="text-align:center;color:#ccc;font-size:12px;margin:10px auto;">
                   <i class="el-icon-info" style="margin-right:6px;"></i>仅支持21年3月下旬后存入的证据核验
               </div>
               <div style="padding:0 24px;width:fit-content;" class="input-btn-seck"
                    v-clipboard:copy="barcode"
                    v-clipboard:success="onCopys" 
                    v-clipboard:error="onErrors"
                >复制编码并前往广州互联网法院核验</div>
            </div>
        </div>
    </div>

</template>

<script>
    // import MyUploadOneHw from '@/views/main-components/my-upload-one-hw';
    import CryptoJS from 'crypto-js';
    import {_getVerifyOperatio, _getTianPing,_getEvidencePack,_getBarcode} from '../../../api/evidence.js';
    import $ from 'jquery';
    import musicIcon from '@/assets/music_icon.png'
    import fileIcon from '@/assets/file_icon.png';
    import textIcon from '@/assets/text_icon.png';
    import videoIcon from '@/assets/video_icon.png';
    const type = ['bat', 'exe', 'com', 'DLL', 'MSI', 'VBS', 'VBE', 'JS', 'JSE', 'WSH', 'WSF', 'PBD', 'PB', 'dmg', 'fcd', 'gdb', 'REG', 'SAV', 'str', 'SYS', 'swf', 'VBP', 'VBW', 'VBX', 'VIR', 'VXD', 'WCM', 'WIZ', 'A', 'ADF'];
    const reImg = /^(bmp|png|jpg|gif|jpeg|JPG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    String.prototype.suffix = function () {
        var index1 = this.lastIndexOf(".");
        var index2 = this.length;
        return this.substring(index1 + 1, index2)
    }
    export default {
        metaInfo: {
            title: '前海版权公共服务平台可信存证核验|版权服务专家|前海版权公共服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权公共服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '前海版权公共服务平台可信存证核验,人人都是创作者，人人都是版权人。前海版权公共服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'creationVerification',
        components:{
            // MyUploadOneHw
        },
        data() {
            return {
                addIcon:'addIcon',
                tipsText:'请选择证据文件',
                returnImg: '',
                uploadProgress:-1,
                flag:false,
                newBlock: false,
                newBlock1: false,
                newBlock2: false,
                newBlock3: false,
                newBlock4: false,
                newBlock5: false,
                newBlock6: false,
                newBlock7: false,
                recodes: "",
                herfUrl: "",
                copyUrls: "",
                tinaPingCode: "",
                rightPhoto:require('@/assets/images/addRight.png'),
                wrongPhoto:require('@/assets/images/addWrong.png'),
                tempUrl:'',
                certPageObj:{},
                fileType:'img',
                temphash:'',
                processData:0,
                showOg: false,
                barcode: '',
                publicHash:''
            }
        },
        methods: {
            onCopys: function (e) {
                toast('复制成功')
                let _this = this
                _this.showOg = false
                window.open('http://bc.gzinternetcourt.gov.cn:9001/gzinternetcourt-evidence/index.html#/netcomchain','_blank')
            },
            onErrors: function (e) {
                toast('复制失败')
            },
            closeZfb() {
                this.showOg = false
            },
            openDaog() {
                if(this.publicHash){
                    this.getBarcode(this.publicHash)
                    this.showOg = true
                }
            },
            getBarcode(url){
                let params = {
                   pulicHash: url 
                }
                let _this = this
                _getBarcode(params).then(res => {
                    if (res.code == 200) {
                        _this.barcode = res.result
                    } else {
                        toast(res.message)
                    }
                })
            },
            arrayBufferToWordArray(ab) {
                var i8a = new Uint8Array(ab);
                var a = [];
                for (var i = 0; i < i8a.length; i += 4) {
                    a.push(i8a[i] << 24 | i8a[i + 1] << 16 | i8a[i + 2] << 8 | i8a[i + 3]);
                }
                return CryptoJS.lib.WordArray.create(a, i8a.length);
            },
            handleBeforeUpload(file){
                let _this = this
                this.uploadProgress = 1;
                _this.processData = 0;
                var filetype = file.name.suffix();
                var reader = new FileReader();
                var blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice;
                var chunkSize = 6 * 1024 * 1024;
                var chunks = Math.ceil(file.size / chunkSize);
                var currentChunk = 0;
                var hasher = CryptoJS.algo.SHA256.create();
                var start = currentChunk * chunkSize;
                var end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                reader.readAsArrayBuffer(blobSlice.call(file, start, end));
                reader.onload = function(evt){
                    var fileStr = evt.target.result;
                    var tmpWordArray = _this.arrayBufferToWordArray(fileStr);
                    hasher.update(tmpWordArray);
                    currentChunk += 1;
                    fileStr = null;
                    tmpWordArray = null;
                    
                    // 判断文件是否都已经读取完
                    if (currentChunk < chunks) {
                        // 计算开始读取的位置
                        var start = currentChunk * chunkSize;
                        _this.processData = Math.round((start/(file.size)*100)*100)/100
                        // 计算结束读取的位置
                        var end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                        reader.readAsArrayBuffer(blobSlice.call(file, start, end));
                    }else{
                        _this.processData = 100
                        let hash = hasher.finalize();
                        // let securityCode = hash.toString(CryptoJS.enc.Hex).toUpperCase();
                        // console.log('输入SHA256: ', hash, '计算结果', securityCode);
                        let securityCode = hash.toString(CryptoJS.enc.Hex)
                        _this.temphash = securityCode
                        console.log('输入SHA256: ', _this.temphash);
                        if(_this.temphash!=''){
                            switch (true) {
                                case reImg.test(filetype):
                                    _this.fileType = 'img';
                                    var url = URL.createObjectURL(file)
                                    // console.log('++++++++++++++',url)
                                    // const reader = new FileReader();
                                    // reader.readAsDataURL(file);
                                    // reader.onloadend = () => {
                                        
                                    //     _this.returnImg = reader.result
                                    // };
                                    _this.returnImg = url;
                                    break;

                                case reMusic.test(filetype):
                                    _this.fileType = 'music';
                                    _this.returnImg = musicIcon;
                                    break;

                                case reText.test(filetype):
                                    _this.fileType = 'text';
                                    _this.returnImg = textIcon;
                                    break;

                                case reVideo.test(filetype):
                                    _this.fileType = 'video';
                                    _this.returnImg = videoIcon;
                                    break;

                                default:
                                    _this.fileType = 'file';
                                    _this.returnImg = fileIcon;
                                    break;
                            }
                            _this.uploadProgress = 0;
                        }
                    }              
                }
                reader.onloadend = function(){
                    // var hash = hasher.finalize();
                }
                // var temp256 = sha256(file); 
                // let reader = new FileReader();
                // reader.readAsArrayBuffer(file);
                // reader.onload = function () {
                //     var wordArray = CryptoJS.lib.WordArray.create(reader.result);
                //     var hash = CryptoJS.SHA256(wordArray).toString();
                //     _this.temphash = hash
                //     if(_this.temphash!=''){
                //         switch (true) {
                //             case reImg.test(filetype):
                //                 _this.fileType = 'img';
                //                 var url = URL.createObjectURL(file)
                //                 // console.log('++++++++++++++',url)
                //                 // const reader = new FileReader();
                //                 // reader.readAsDataURL(file);
                //                 // reader.onloadend = () => {
                                    
                //                 //     _this.returnImg = reader.result
                //                 // };
                //                 _this.returnImg = url;
                //                 break;

                //             case reMusic.test(filetype):
                //                 _this.fileType = 'music';
                //                 _this.returnImg = musicIcon;
                //                 break;

                //             case reText.test(filetype):
                //                 _this.fileType = 'text';
                //                 _this.returnImg = textIcon;
                //                 break;

                //             case reVideo.test(filetype):
                //                 _this.fileType = 'video';
                //                 _this.returnImg = videoIcon;
                //                 break;

                //             default:
                //                 _this.fileType = 'file';
                //                 _this.returnImg = fileIcon;
                //                 break;
                //         }
                //         _this.uploadProgress = 0;
                //     }
                //     console.log('++++++++++++++++++++++',hash)
                // };
                
                 return false;
                
            },
            //显示或隐藏 具体使用方式
            changeImg(event) {
                event.stopPropagation();
                const num = event.currentTarget.getAttribute("data-num");
                switch (num) {
                    case "0":
                        this.newBlock = true
                        break;
                    case "1":
                        this.newBlock1 = true
                        break;
                    case "2":
                        this.newBlock2 = true
                        break;
                    case "3":
                        this.newBlock3 = true
                        break;
                    case "4":
                        this.newBlock4 = true
                        break;
                    case "5":
                        this.newBlock5 = true
                        break;
                    case "6":
                        this.newBlock6 = true
                        break;
                    case "7":
                        this.newBlock7 = true
                        break;
                }
            },
            // showMessageFromWorksChild(value){
            //     console.log('获取到的还在',value)
            //     this.tempUrl = value
            // },
            hideImg() {
                this.newBlock = false;
                this.newBlock1 = false;
                this.newBlock2 = false;
                this.newBlock3 = false;
                this.newBlock4 = false;
                this.newBlock5 = false;
                this.newBlock6 = false;
                this.newBlock7 = false;

            },
            //获取核验
            getVerifyOperatio() {
                const data = {
                    businessType: this.$route.params.type,
                    orderSeqNo: this.$route.params.id
                }
                _getVerifyOperatio(data).then(res => {
                    if (res.code == 200) {
                        this.recodes = res.result;
                        this.getBarcode(res.result.publicHash)
                        this.publicHash = res.result && res.result.publicHash ? res.result.publicHash :''
                        this.herfUrl = this.API_ROOT_UPLOAD + 'bqjvip/verifyOperation/cbca/' + res.result.publicHash;
                        this.copyUrls = '签名结果：' + res.result.caSignResult + `\n` + '签名公钥：' + res.result.caPubKey
                        this.getTianPing(res.result.publicHash)
                    } else {
                        toast(res.message)
                    }
                });
            },
            //获取天平链数据
            getTianPing(val) {
                _getTianPing({pulicHash: val}).then((res) => {
                    if (res.code == 200) {
                        this.tinaPingCode = res.result.data.txid0
                    } else {
                        // toast(res.message)
                    }
                })
            },
            //收起
            closelistclick(e) {
                $(e.currentTarget).parents().siblings(".zhankaiBox").css("display", "block");
                $(e.currentTarget).parents(".zhankaiBox2").css("display", "none");
            },
            //展开
            newslistclick(e) {
                $(e.currentTarget).parents(".zhankaiBox").css("display", "none");
                $(e.currentTarget).parents().siblings(".zhankaiBox2").css("display", "block");
                $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox2").css("display", "none");
                $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox").css("display", "block");
            },
            twolistclick(e) {
                $(e.currentTarget).parents(".zhankaiBox").css("display", "none");
                $(e.currentTarget).parents().siblings(".zhankaiBox2").css("display", "block");
                $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox2").css("display", "none");
                $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox").css("display", "block");
            },
            //复制
            onCopy(e) {
                toast("复制成功");
            },
            onError(e) {
                toast("复制失败");
            },

            testClick:function () {
                this.test = !this.test;
                console.log(this.test)
            },
            getEvidencePack(){
                if(this.returnImg== ''){
                    toast('请选择证据上传后校验');
                    return false;
                }
                let data = {
                    businessType: this.$route.params.type,
                    orderSeqNo: this.$route.params.id,
                    hash:this.temphash
                }
                _getEvidencePack(data).then(res=>{
                    if(res.code == 200){
                        this.certPageObj = res.result
                        this.flag = true
                    }else{
                        toast(res.message);
                    }
                })
            }

        },
        mounted() {
            this.getVerifyOperatio()
        }
    }
</script>
<style lang="less" scoped>
.mydiag{
        position:fixed;
        top:0px;
        bottom:0px;
        left:0px;
        right:0px;
        margin:auto;
        background:rgba(0,0,0,0.25);
        z-index:555;
        .mydiag_content{
            position:absolute;
            top:0px;
            bottom:0px;
            left:0px;
            right:0px;
            margin:auto;
            width:584px;
            height:230px;
            background: #ffffff;
            border-radius: 8px;
            .mydiag_title{
                height:75px;
                // border-bottom:1px solid #ececec;
                display: flex;
                justify-content: space-between;
                align-items: center;
                div{
                    font-size: 16px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    margin-left:30px;
                    color: #323232;
                }
                img{
                    width:18px;
                    height:18px;
                    margin-right:30px;
                    cursor:pointer;
                }
            }
            .mydiag_tonle{
                width:440px;
                height:40px;
                border: 1px solid rgba(9, 9, 7, 0.17);
                user-select: none;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 auto;
            }
        }
    }
    .vmain-content{
        width: 1334px;
    }
    .verification_anchor {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
        width: 205px;
        height: 266px;
        padding: 20px 0;
        box-sizing: border-box;
        margin-right: 50px;
        margin-top: 200px;
    }

    /deep/ .ivu-affix{
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
        width: 205px;
        height: 266px;
        padding: 20px 0;
        box-sizing: border-box;

    }

    /deep/ .verification_anchor .ivu-anchor {
        padding-left: 0;
    }

    /deep/ .verification_anchor .ivu-anchor-ink {
        display: none;
    }

    .verification_anchor .verification_anchor_link {
        height: 40px;
        line-height: 40px;
        color: #1A1A1A;
        font-size: 16px;
        padding: 0 0 0 39px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 5px;
    }

    .verification_anchor .verification_anchor_link:first-child{

    }

    .verification_anchor .verification_anchor_link.ivu-anchor-link-active {
        background: rgba(255, 216, 0, 0.091);
        border-left: 4px solid #FFD800;
    }

    /*.verification_anchor .verification_anchor_link.ivu-anchor-link-active:before{*/
    /*    content: '';*/
    /*    padding-left*/
    /*}*/

    /deep/ .verification_anchor .ivu-anchor-link-title {
        transition: none;
    }

    /deep/ .verification_anchor .ivu-anchor-link-active > .ivu-anchor-link-title {
        color: #1A1A1A;
        margin-left: -4px;

    }

    /deep/ .verification_anchor .ivu-anchor-link-title:hover {
        color: #1A1A1A;
    }
    .mewAddsty{
        display:flex;
        justify-content: flex-start;
        border-bottom:1px solid #eee;
        .mewAddsty_left{
            margin-top:36px;
            margin-right:40px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            margin-left: 35px;
        }
        .mewAddsty_right{
            display:flex;
            flex-direction: column;
            margin-top:36px;
            .mewAddsty_btn{
                margin-top:28px;
                cursor:pointer;
                width: 173px;
                height: 42px;
                background: #F8D900;
                border-radius: 4px;          
                font-size: 14px;
                font-weight: 400;
                color: #323232;
                display:flex;
                justify-content: center;
                align-items: center;
                margin-bottom:36px;
            }
            .myupleft{
                text-align: center;
                /deep/ .ivu-upload{
                    width:175px;
                }
            }
            /deep/ .vertical_upload .ivu-upload {
                width: 100%;
                height: 100%;
                display: flex;
            }

            /deep/ .vertical_upload .ivu-upload {
                width: 100%;
                height: 100%;
                display: flex;
            }

            /deep/ .ivu-upload-drag {
                border: none;
            }

            .upload_text {
                align-self: center;
                margin: 0 auto;
                color: #999;
                font-size: 12px;
            }

            .upload_ing {
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, .5);
                display: flex;
            }

            .upload_ing .upload_ing_text {
                // color: #fff;
                // align-self: center;
                // margin: 0 auto;
                width: 100%;
            }
            .upload_ing_text{
                display:flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position:relative;
                .upload_ing_desc{
                    font-size: 24px;
                    font-weight: 500;
                    line-height: 33px;
                    color: #F7B500;
                }
                .upload_progress_shadow{
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    background: rgba(255, 216, 0, 0.3);
                    border-radius: 4px;
                    transition: all 100ms;
                }
            }
            .upload_success {
                position: relative;
                width: 100%;
            }

            .upload_success .upload_success_img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .upload_success:after {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: rgba(0, 0, 0, .5);
                z-index: 2;
            }

            .upload_success .upload_success_btn {
                width: 82px;
                height: 26px;
                line-height: 26px;
                background: rgba(255, 216, 0, 1);
                text-align: center;
                cursor: pointer;
                border-radius: 2px;
                color: #4E4E4E;
                position: absolute;
                left: 50%;
                top: 50%;
                z-index: 3;
                font-size: 14px;
                margin: -13px 0 0 -41px;
                transition: .3s ease-out;
            }

            .upload_success .upload_success_btn:hover {
                color: #fff;
                background-color: #cf7700;
                border-color: #cf7700;
            }

            .upload_text .upload_text_add {
                color: #A9A9A9;
                font-size: 40px;
                line-height: 1;
                margin-bottom: 9px;
            }

            .upload_text .upload_text_tips {
                padding-top: 10px;
                color: #333;
                font-size: 14px;
                line-height: 1;
            }

            /deep/ .ivu-date-picker .ivu-input {
                width: 100%;
            }
        }
    }
    .mewAddsty_bottom{
        display:flex;
        justify-content: flex-start;
        .mewAddsty_bottom_left{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            margin-top:36px;
            margin-right:40px;
            margin-left: 77px;
        }
        .mewAddsty_bottom_right{
            display:flex;
            flex-direction: column;
            margin-top:36px;
            .mewAddsty_bottom_right1{
                display:flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom:15px;
                .mewAddsty_bottom_right1_1{
                    width:27px;
                    height:27px;
                }
                .mewAddsty_bottom_right1_2{
                    margin-left:8px;               
                    height: 33px;
                    font-size: 24px;
                    font-weight: 500;
                    color: #FA6400;
                    line-height: 33px;
                }
            }
            .mewAddsty_bottom_right2{
                height: 20px;
                font-size: 14px;
                font-weight: bold;
                color: #333333;
                line-height: 20px;
                margin-bottom:28px;
            }
            .mewAddsty_bottom_right3{
                display:flex;
                flex-direction: column;
                p{
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 20px;
                    margin-bottom:8px;
                }
            }
        }
    }
</style>